export default {
    commonConfiguration: {
        Notification: {},
        Message: {
            error: 'Server error'
        },
        Alert: {},
        Button: {
            confirm: 'Confirm',
            back: 'Back',
            cancel: 'Cancel',
            login: 'Login',
            loggedIn: 'Logged In',
            logout: 'Logout',
            mallCenter: 'Digital Trading Center',
            regist: 'Register',
            More: 'More',
            SeeMore: 'View More',
            button1: 'Search',
            button3: 'Account Management',
            button4: 'Seller Portal',
            button5: 'Buyer Dashboard',
            button6: 'My Orders',
            button7: 'Account Info',
            button8: 'Account Security',
            button9: 'Enterprise Verification',
            button10: 'My Purchase List',
            button11: 'My Account',
            button12: 'Shopping Cart',
            button13: 'Messages',
            button14: 'Back to Top'
        },
        Footer: {
            Landline: 'Contact Phone',
            LandlineNumber: '0536-7267526',
            Email: 'Contact Email',
            EmailAddress: 'nfstzx@nfstzx.com',
            ContactAddress: 'Address',
            ContactAddressContent: 'Building A, Headquarters Base, National Agricultural Open Development Comprehensive Pilot Zone, Weifang, Shandong Province',
            FriendLinks: 'Quick Links',
            AboutThePlatform: 'About Platform',
            AboutUs: 'About Us',
            TermsOfService: 'Terms of Service',
            PrivacyPolicy: 'Privacy Policy',
            ServiceAgreement: 'Service Agreement',
            HelpCenter: 'Help Center',
            DownloadUserManual: 'User Manual',
            FeedbackAndSuggestions: 'Feedback',
            PublicConsultation: 'Public Consultation',
            Copyright: 'Weifang Agricultural Open Development Group Co., Ltd.'
        },
        Href: {
            href1: 'China International Poverty Reduction Center',
            href2: 'MOA International Exchange Service Center',
            href3: 'MOA Department of International Cooperation',
            href4: 'MOA Agricultural Trade Promotion Center',
            href5: 'MOA Foreign Economic Cooperation Center'
        },
        Placeholder: {
            placeholder1: 'Search for products...',
        },
        Validate: {},
        Description: {
            hello: 'Hello, welcome to',
            Loggedin: 'Logged In'
        },
        Checkbox: {},
        Table: {}
    }
}